import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiDelete, apiPut } from "../../api/index";
import { urlMovementSecured, urlExportMovementSecured } from "../../api/urls";
import moment from "moment-timezone";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.status) filter += "&status=" + filters.status;
    if (filters.batch) filter += "&batch=" + filters.batch;
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Filter list movements.
 */
export const filterMovement = createAction("FILTER_MOVEMENT", (filter, param) =>
  apiGet(urlMovementSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Export stock.
 */
export const listMoveToExport = createAction(
  "EXPORT_FILTER_MOVEMENT",
  (filter, param) =>
    apiGet(
      urlExportMovementSecured + generateFilterQuery(filter),
      param,
      true
    )()
);

/**
 * Register process.
 */
export const confirmMov = createAction("CONFIRM_MOVEMENT", (obj) =>
  apiPost(urlMovementSecured, obj, undefined)()
);
